import { LOGIN, AUTHORIZE } from './keys'
import * as api from '@/store/api/auth'
import { proxyActions } from '@/store/vuex-helper'
import { Commit, Store } from 'vuex'

export default {
  [LOGIN] (store: Store<any>, { authType, data }: { authType: string, data: any}) {
    return proxyActions(async () => (await api.login(authType, data)).data, LOGIN)
  },

  [AUTHORIZE] (store: Store<any>, approve: boolean) {
    const params = {
      'user_oauth_approval': true,
      'scope.login': approve,
      'authorize': 'Authorize'
    }
    return proxyActions(() => api.authorize(params), AUTHORIZE)
  }
}
